module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/glyphicons-halflings-regular.ttf
// module id = M+3f
// module chunks = 0